import { render, staticRenderFns } from "./setMenu.vue?vue&type=template&id=dfbd6ec6&scoped=true&"
import script from "./setMenu.vue?vue&type=script&lang=js&"
export * from "./setMenu.vue?vue&type=script&lang=js&"
import style0 from "./setMenu.vue?vue&type=style&index=0&id=dfbd6ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbd6ec6",
  null
  
)

export default component.exports